import { Actions, ActionTypes } from './actions';
import { adapter, initialState, SearchServiceState } from './state';

export function reducer(state = initialState, action: Actions): SearchServiceState {
  switch (action.type) {
    case ActionTypes.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case ActionTypes.SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ActionTypes.SEARCH_SUCCESS:
      return adapter.setAll(action.items, {
        ...state,
        isLoading: false,
        error: null,
      });
    case ActionTypes.SET_SELECTED_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.SET_SELECTED_SUCCESS: {
      return {
        ...state,
        selected: { ...action.model },
        isLoading: false,
        error: null,
      };
    }

    default:
      return state;
  }
}
